import store from '@/store';

export default class EndChatEvent {
  constructor(body) {
    store.dispatch('jobs/disableJob', body.protocol);
    store.dispatch('jobs/updateAgentStatusChat');
    store.dispatch('showSnackbar', { text: 'endChatByClient' });
  }
}
